import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace AgentSubscriptionValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const InvoiceRecord = defineValidation(BaseRecordSchema);
}
